import { render } from "./ProfileImageCapture.vue?vue&type=template&id=0adb3785"
import script from "./ProfileImageCapture.vue?vue&type=script&lang=js"
export * from "./ProfileImageCapture.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\supportgroup\\admin.supportgroup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__